// "Multi Tracking System" setting, mirroring Android's
// user_setting_multi_tracking_enabled (DataStore). On web it lives in
// localStorage only — no Firebase persistence yet (settings stay local, same
// spirit as Android keeping preferences device-local).
//
// Default ON: freelancers commonly track several tasks (and human + AI) in
// parallel, matching Android's default.
export const MULTI_TRACKING_KEY = "user_setting_multi_tracking_enabled";

export const isMultiTrackingEnabled = () => {
  try {
    const v = localStorage.getItem(MULTI_TRACKING_KEY);
    return v === null ? true : v === "true";
  } catch (e) {
    return true;
  }
};

export const setMultiTrackingEnabled = (enabled) => {
  try {
    localStorage.setItem(MULTI_TRACKING_KEY, String(enabled));
  } catch (e) {
    /* ignore */
  }
};
